import { render } from "./TagManage.vue?vue&type=template&id=2d0b0bc5&scoped=true"
import script from "./TagManage.vue?vue&type=script&lang=js"
export * from "./TagManage.vue?vue&type=script&lang=js"

import "./TagManage.vue?vue&type=style&index=0&id=2d0b0bc5&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0b0bc5"]])

export default __exports__